export const state = getInitialState();

export function getInitialState() {
  return {
    invoiceStatus: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    paymentStatus: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    levyComponents: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    noticeCounts: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    providerLevyAmounts: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    providerStatus: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    activityForWeek: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    },
    activityForYear: {
      levyCollectionId: null,
      loading: false,
      loaded: false,
      data: null
    }
  };
}

export function getUnloadedState() {
  return {
    invoiceStatus: { loaded: false },
    paymentStatus: { loaded: false },
    levyComponents: { loaded: false },
    noticeCounts: { loaded: false },
    providerLevyAmounts: { loaded: false },
    providerStatus: { loaded: false },
    activityForWeek: { loaded: false },
    activityForYear: { loaded: false }
  };
}
